import JSZip from 'jszip';
import { storage } from "../apis/firebase";
import { ref, getDownloadURL, getMetadata, uploadBytesResumable, deleteObject } from 'firebase/storage';
/**
 * Firebase Storageから指定されたパスのCSVファイルを取得し、内部データとしてシステムで利用できるようにします。
 * @param pathToFile ファイルへのパス
 */
export async function downloadGcsFile(pathToFile) {
    try {
        const fileRef = ref(storage, pathToFile);
        const url = await getDownloadURL(fileRef);
        const response = await fetch(url);
        const csvText = await response.text(); // CSVファイルの内容をテキストとして取得
    }
    catch (error) {
        console.error("Error loading CSV file:", error);
    }
}
/**
 * ZIPファイルをダウンロードし、その内容を展開します。
 *
 * @param pathToFile ファイルへのパス
 * @param fileName ZIPファイル内で取得対象のファイル名
 *
 */
export async function downloadAndUnzipFile(pathToFile, fileName) {
    try {
        const fileRef = ref(storage, pathToFile);
        const url = await getDownloadURL(fileRef);
        const response = await fetch(url);
        const blob = await response.blob();
        const zip = new JSZip();
        const contents = await zip.loadAsync(blob); // ZIPファイルの内容を読み込む
        if (contents.files[fileName]) {
            const fileData = await contents.files[fileName].async('text');
            return fileData; // 特定のファイルの内容を文字列として返す
        }
        else {
            throw new Error(`File ${fileName} not found in the ZIP archive.`);
        }
    }
    catch (error) {
        console.error('Error processing zip file:', error);
        throw error; // エラーを呼び出し元に伝播させる
    }
}
/**
 * Firebase Storage(Google Cloud Storage)より指定されたパスのファイルをローカルファイルとしてダウンロードします。
 * @param pathToFile ファイルへのパス
 * @param filename ダウンロード時のファイル名
 */
export async function downloadGcsFileToLocal(pathToFile, filename) {
    try {
        const fileRef = ref(storage, pathToFile);
        const url = await getDownloadURL(fileRef);
        console.log(url);
        const response = await fetch(url);
        console.log(response);
        const blob = await response.blob();
        saveFile(blob, filename);
    }
    catch (error) {
        console.error("Error downloading file:", error);
        throw error;
    }
}
export async function uploadGcsFile(gcsPath, file) {
    try {
        const fileRef = ref(storage, gcsPath);
        await uploadBytesResumable(fileRef, file);
    }
    catch (error) {
        console.error('Upload failed:', error);
        throw error;
    }
}
/**
 * Firebase Storage(Google Cloud Storage)上のファイルのアップロード日時(ISO8601)を取得します。
 * 同一パスへ上書きアップロードされた場合は、最後にアップロードされた日時になります。
 * @param pathToFile ファイルへのパス
 */
export async function getGcsFileUploadedAt(pathToFile) {
    const fileRef = ref(storage, pathToFile);
    const metadata = await getMetadata(fileRef);
    return metadata.timeCreated;
}
export async function deleteGcsFile(gcsPath) {
    const fileRef = ref(storage, gcsPath);
    await deleteObject(fileRef);
}
/**
* ブラウザでファイルをダウンロードするための関数。
* @param blob ダウンロードするファイルのBlob
* @param filename ダウンロード時のファイル名
*/
function saveFile(blob, filename) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    // Cleanup
    URL.revokeObjectURL(link.href);
    link.remove();
}
